import { keyframes } from "@emotion/react"

export const API_BASE = window.location.href.startsWith('http://localhost:3000') ? `http://localhost:8090/`
  : window.location.href.startsWith('https://testapp.rentfinder.ai/') ? `https://api-test.rentfinder.ai/`
    : window.location.href.startsWith('https://testlite.rentfinder.ai/') ? `https://apilite-test.rentfinder.ai/`
      : window.location.href.startsWith('https://lite.rentfinder.ai/') ? `https://apilite.rentfinder.ai/`
        : window.location.href.startsWith('https://app2.rentfinder.ai/') ? `https://api2.rentfinder.ai/`
          : window.location.href.startsWith('https://testapp2.rentfinder.ai/') ? `https://testapi2.rentfinder.ai/`
            : `https://api2.rentfinder.ai/`

export const PDF_BASE = window.location.href.startsWith('http://localhost:3000') ? `http://localhost:3001/`
  : 'https://miahuxzgin.us-east-1.awsapprunner.com/'

export const IS_LITE = window.location.href.startsWith('http://localhost:3001')
  || window.location.href.startsWith('https://testlite.rentfinder.ai/')
  || window.location.href.startsWith('https://lite.rentfinder.ai/')
export const IS_STRIPE_TEST = window.location.href.startsWith('http://localhost:3000')
  || window.location.href.startsWith('https://testapp.rentfinder.ai/')
  || window.location.href.startsWith('https://testlite.rentfinder.ai/')

export const API_URL = window.location.href.startsWith('http://localhost:3000') ? `http://localhost:8090`
  : window.location.href.startsWith('https://testapp.rentfinder.ai/') ? `https://testapi.rentfinder.ai`
    : `https://api.rentfinder.ai`
// stored in riq_app_config#app.token.lite.allowed.jwt
export const LITE_TOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiQW5hbmQgWGZvcmlhIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hL0FHTm15eGFnb3FiMmt0dTRKTmlocWpIUEoxRThoQmhaazVLMWNkT0JuaVJmPXM5Ni1jIiwiaXNzIjoiaHR0cHM6Ly9zZWN1cmV0b2tlbi5nb29nbGUuY29tL3JlbnQtaXEiLCJhdWQiOiJyZW50LWlxIiwiYXV0aF90aW1lIjoxNjg2MzMyNTEzLCJ1c2VyX2lkIjoibmV3bWlTQmxGM08xbHBPQ1FJTHVGMmFRcEc4MiIsInN1YiI6Im5ld21pU0JsRjNPMWxwT0NRSUx1RjJhUXBHODIiLCJpYXQiOjE2ODk2OTA0ODgsImV4cCI6NDY4OTY5NDA4OCwiZW1haWwiOiJhbGl0ZWF1dGhAcmVudGZpbmRlci5haSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJmaXJlYmFzZSI6eyJpZGVudGl0aWVzIjp7Imdvb2dsZS5jb20iOlsiMTAwMTc0MjQwOTM1OTUzNTE4Mjc3Il0sImVtYWlsIjpbImFsaXRlYXV0aEByZW50ZmluZGVyLmFpIl19LCJzaWduX2luX3Byb3ZpZGVyIjoiZ29vZ2xlLmNvbSJ9fQ.bwBo6a5Vy6Z82h9bb_ltD-bcF_0n_QFwFcGCMiBI72I`

export const MAX_AGE_FOR_AUTO_TOUR = 86400000 // 24 hours

// https://firebase.google.com/docs/reference/js/auth#autherrorcodes
const authFultCodeToMsg = new Map<string, string>()
authFultCodeToMsg.set('auth/email-already-in-use', 'Email already in use')
authFultCodeToMsg.set('auth/email-change-needs-verification', 'Email needs verification')
authFultCodeToMsg.set('auth/requires-recent-login', 'Please relogin, crednetial expired')
authFultCodeToMsg.set('auth/invalid-email', 'Invalid email')
authFultCodeToMsg.set('auth/user-not-found', 'Email not found, you need to register this email first')

export const authFultMsgById = (id: string): string => {
  const rsp = authFultCodeToMsg.get(id)
  return rsp ? rsp : `Unknown error - ${id}`
}



export const dpsf = (rent: number, sqft: number) => {
  if (!rent || !sqft || sqft === 0) {
    return 0
  }
  try {
    return (rent / sqft).toFixed(3)
  } catch (e) {
    return 0
  }
}


export const spinAnim = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
  `